import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2.4 6v15.6H18V18h1.2v4.8h-18v-18H6V6H2.4z" /><path fillRule="evenodd" clipRule="evenodd" d="M21.6 2.4H6V18h15.6V2.4zM4.8 1.2v18h18v-18h-18z" /><path d="M12 13.2v-6l4.8 3-4.8 3z" /></svg>;